//
// This plugin detects when something user related changes and ensures that client-side and server-side user
// data is kept in sync.
//

import { setupUser } from '~/composables/user'
import { useGraphqlFetch } from '~/composables/craft-fetch'
import { useJwtStore } from '~/store/jwt'
import { useSearchProfilesStore } from '~/store/searchProfiles'
import { useWishListStore } from '~/store/wishList'

export default defineNuxtPlugin(() => {
  const jwtStore = useJwtStore()
  const searchProfilesStore = useSearchProfilesStore()
  const wishListStore = useWishListStore()
  const graphqlFetch = useGraphqlFetch()

  const updateServerSideSearchProfiles = async (checkToken: () => Promise<boolean>, searchProfiles: any) => {
    if (!(await checkToken())) {
      return false
    }

    if (!Array.isArray(searchProfiles)) {
      return false
    }

    try {
      await graphqlFetch({
        headers: { Authorization: `JWT ${jwtStore.token}` }, // Accessing token from Pinia state
        query: `
          mutation updateViewer($searchProfiles: String) {
            user: updateViewer(userSearchProfiles: $searchProfiles) {
              uid
            }
          }
        `,
        variables: {
          searchProfiles: JSON.stringify(searchProfiles),
        },
        params: {
          'no-cache': 'true',
        },
      })
    } catch {
      return false
    }
    return true
  }

  const updateServerSideWishList = async (checkToken: () => Promise<boolean>, wishList: any) => {
    if (!(await checkToken())) {
      return false
    }

    if (!Array.isArray(wishList)) {
      return false
    }

    try {
      await graphqlFetch({
        headers: { Authorization: `JWT ${jwtStore.token}` }, // Accessing token from Pinia state
        query: `
          mutation updateViewer($wishList: String) {
            updateViewer(userWishList: $wishList) {
              uid
            }
          }
        `,
        variables: {
          wishList: JSON.stringify(wishList),
        },
        params: {
          'no-cache': 'true',
        },
      })
    } catch {
      return false
    }
    return true
  }

  const { checkToken } = setupUser()

  // Update the server-side data whenever the store changes
  searchProfilesStore.$subscribe((_mutation, state) => {
    updateServerSideSearchProfiles(checkToken, state.profiles)
  })
  wishListStore.$subscribe((_mutation, state) => {
    updateServerSideWishList(checkToken, state.profile)
  })
})
